import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ErrorPage } from "./pages/ErrorPage/ErrorPage.js";
import Header from "./components/Header/Header.js";
import Footer from "./components/Footer/Footer.js";
import UngriefChat from "./components/UngriefChat/UngriefChat.js";
import Login from "./components/Authentication/Login/Login.js";
import SignUp from "./components/Authentication/SignUp/SignUp.js";
import AboutPage from "./pages/AboutPage/AboutPage.js";
import HomePage from "./pages/HomePage/HomePage.js";
import MedHelpPage from "./pages/MedHelpPage/MedHelpPage.js";
import TherapistPage from "./pages/TherapistPage/TherapistPage.js";
import StoriesPage from "./pages/StoriesPage/StoriesPage.js";
import VideosPage from "./pages/VideosPage/VideosPage.js";
import DisclaimerPage from "./pages/DisclaimerPage/DisclaimerPage.js";
import StoryDetailPage from "./pages/StoryDetailPage/StoryDetailPage.js";
import RouteProtection from "./components/RouteProtection";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Header />
      </div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route element={<RouteProtection />}>
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/storyDetail/:id" element={<StoryDetailPage />} />
        </Route>
        <Route path="/songs" element={<VideosPage />} />
        <Route path="/medHelp" element={<MedHelpPage />} />
        <Route path="/therapists" element={<TherapistPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signUp" element={<SignUp />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        {/* <Route path="/peersupport" element={<UngriefChat />} /> */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
